import { config, handleResponse } from '../../_helpers';

export const bookingServices = {
    getBookingSchedules,
    getVoyageForBookingBatch,
    getBookingBatchByVoyageNum,
    loadBookingBatchByVoyageNum,
    CreateBookingBatch,
    updateBookingBatch,
    deleteByBatch,
    sendEmail,
    getBookingBatch,
    createBookingRef,
    deleteByBookingRef,
    getBookingRef,
    cloneBookingRef,
    getMultipleBookingRef,
    getBookingLink,
    searchBooking,
    updateBookingBatchStatus,
    updateMultipleBookingRef,
    updateSingleBooking,
    updateMultipleBookingStatus,
    getVanOutATW,
    getCyBranch,
    getBookingPickUpList,
    getBookingDeliveryListInBound,
    getAllBookingbyVoyageNum,
    loadAllBookingbyVoyageNum,

    operationreports,
    getBookingForCBS,

    bookingReports1,
    bookingByCsrReports,
    voyageHistory,
    sQbasedCommodityReports,
    vesselHistoryReports,

    BookingDocumentTree,

    soundingsReport,
    soundingsReportYear,
    soundingsReportMonth,
    soundingsReportVessel,
    getTallysheetFinalization,
    updateSoundingsReport,

    // REPORTS API
    dwelltimeReport,

    expireBooking,

    revenueReport,

    revenueReportComparative,
};

function expireBooking(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/expireBooking`, requestOptions).then(handleResponse);
}

function soundingsReport(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Bookings/soundingsReport`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Bookings/soundingsReportV1`, requestOptions).then(handleResponse);
}
function soundingsReportYear() {
    const requestOptions = {
        method: 'POST',
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/soundingsReportYear`, requestOptions).then(handleResponse);
}
function soundingsReportMonth(year) {
    const requestOptions = {
        method: 'POST',
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/soundingsReportMonth/${year}`, requestOptions).then(handleResponse);
}
function soundingsReportVessel(month) {
    const requestOptions = {
        method: 'POST',
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/soundingsReportVessel/${month}`, requestOptions).then(handleResponse);
}
function getTallysheetFinalization(id) {
    // const requestOptions = {
    //     method: 'GET',
    //     headers: {
    //         "Content-type": "application/json; charset=UTF-8"
    //     }
    // };
    // return fetch(`${config.apiUrl}/Bookings/getTallysheetFinalization/${id}`, requestOptions).then(handleResponse);
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/getTallysheetFinalizationV1`, requestOptions).then(handleResponse);
}
function updateSoundingsReport(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Bookings/updateSoundingsReport`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Bookings/updateSoundingsReportV1`, requestOptions).then(handleResponse);
}

function BookingDocumentTree(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/BookingDocumentTree`, requestOptions).then(handleResponse);
}

function getBookingForCBS(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/getBookingForCBS`, requestOptions).then(handleResponse);
}

function bookingReports1(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/bookingReports1`, requestOptions).then(handleResponse);
}

function bookingByCsrReports(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/bookingByCsrReports`, requestOptions).then(handleResponse);
}

function voyageHistory(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/voyageHistory`, requestOptions).then(handleResponse);
}

function vesselHistoryReports(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/vesselHistoryReports`, requestOptions).then(handleResponse);
}

function sQbasedCommodityReports(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/sQbasedCommodityReports`, requestOptions).then(handleResponse);
}

function operationreports(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/operationreports`, requestOptions).then(handleResponse);
}

function getBookingSchedules() {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/Bookings/getVoyageBooking`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Bookings/getScheduleForBooking`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Bookings/getScheduleForBookingV1`, requestOptions).then(handleResponse);
}
function getVoyageForBookingBatch(voyageNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Bookings/getVoyageForBookingBatch/${voyageNum}`, requestOptions).then(handleResponse);
}
function getBookingBatchByVoyageNum(voyageNum, search) {
    const requestOptions = {
        method: 'GET'
    };
    // if (search) {
    //     return fetch(`${config.apiUrl}/Bookings/getAllbyVoyageNum/${voyageNum}?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/Bookings/getAllbyVoyageNum/${voyageNum}`, requestOptions).then(handleResponse);
    // }
    if (search) {
        return fetch(`${config.apiUrl}/Bookings/getBookingBatchByVoyageNum/${voyageNum}?search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/Bookings/getBookingBatchByVoyageNum/${voyageNum}`, requestOptions).then(handleResponse);
    }
}
function loadBookingBatchByVoyageNum(voyageNum, search, skip, take) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/Bookings/loadBookingBatchByVoyageNum/${voyageNum}?search=${search}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/Bookings/loadBookingBatchByVoyageNum/${voyageNum}?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function CreateBookingBatch(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/CreateBookingBatch`, requestOptions).then(handleResponse);
}
function updateBookingBatch(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/updateBookingBatch/${id}`, requestOptions).then(handleResponse);
}
function deleteByBatch(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/deleteByBatch`, requestOptions).then(handleResponse);
}
function sendEmail(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/sendEmail`, requestOptions).then(handleResponse);
}
function getBookingBatch(ref, voyageNum, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/Bookings/getBookingBatchRef/${ref}?voyageNum=${voyageNum}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        if (voyageNum) {
            return fetch(`${config.apiUrl}/Bookings/getBookingBatchRef/${ref}?voyageNum=${voyageNum}`, requestOptions).then(handleResponse);
        }
        else {
            return fetch(`${config.apiUrl}/Bookings/getBookingBatchRef/${ref}`, requestOptions).then(handleResponse);
        }
    }
    // if (search) {
    //     return fetch(`${config.apiUrl}/Bookings/getBookingBatch/${ref}?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/Bookings/getBookingBatch/${ref}`, requestOptions).then(handleResponse);
    // }
}
function createBookingRef(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Bookings/CreateBookingRef`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Bookings/CreateBookingRefV1`, requestOptions).then(handleResponse);
}
function deleteByBookingRef(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/deleteByBookingRef`, requestOptions).then(handleResponse);
}
function cloneBookingRef(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/CloneBookingRef`, requestOptions).then(handleResponse);
}
function getBookingRef(ref) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Bookings/getBookingRef/${ref}`, requestOptions).then(handleResponse);
}
function getMultipleBookingRef(ref) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(ref),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/getMultipleBookingRef`, requestOptions).then(handleResponse);
}
function getBookingLink(token) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Bookings/getLink?token=${token}`, requestOptions).then(handleResponse);
}
function searchBooking(skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Bookings/searchBooking?skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
}
function updateBookingBatchStatus(data) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/updateBookingBatchStatus`, requestOptions).then(handleResponse);
}
function updateMultipleBookingRef(Ref, Booking) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify({
            bookingRef: Ref,
            updateBooking: Booking
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/updateMultipleBookingRef`, requestOptions).then(handleResponse);
}
function updateSingleBooking(Ref, Booking) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(Booking),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Bookings/updateSingleBooking/${Ref}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Bookings/updateSingleBookingStrippingStuffing/${Ref}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Bookings/updateBookingVia/${Ref}`, requestOptions).then(handleResponse);
}
function updateMultipleBookingStatus(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Bookings/updateMultipleBookingStatus`, requestOptions).then(handleResponse);
}
function getVanOutATW(bookingRef) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Bookings/getVanOutATW/${bookingRef}`, requestOptions).then(handleResponse);
}

function getCyBranch(userBranch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Bookings/getCyBranch/${userBranch}`, requestOptions).then(handleResponse);
}

function getBookingPickUpList(userBranch, date) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/Bookings/getBookingPickUpList?userBranch=${userBranch}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Bookings/getBookingPickUpListByDate?userBranch=${userBranch}&pickUpDate=${date}`, requestOptions).then(handleResponse);
}

function getBookingDeliveryListInBound(userBranch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Bookings/getBookingDeliveryListInBound?userBranch=${userBranch}`, requestOptions).then(handleResponse);
}

function getAllBookingbyVoyageNum(voyageNum, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/Bookings/getAllBookingbyVoyageNum/${voyageNum}?search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/Bookings/getAllBookingbyVoyageNum/${voyageNum}`, requestOptions).then(handleResponse);
    }
}
function loadAllBookingbyVoyageNum(voyageNum, search, skip, take) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/Bookings/loadAllBookingbyVoyageNum/${voyageNum}?search=${search}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/Bookings/loadAllBookingbyVoyageNum/${voyageNum}?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}

// REPORT API
function dwelltimeReport(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Reports/dwelltimeReport`, requestOptions).then(handleResponse);
}

function revenueReport(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Reports/revenueReport`, requestOptions).then(handleResponse);
}

function revenueReportComparative(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Reports/revenueReportComparative`, requestOptions).then(handleResponse);
}